<template>
    <div class="live content h-screen w-screen fixed flex-row flex overflow-hidden">
        <div v-if="loading" class="w-full h-full flex flex-col justify-center content-center items-center uppercase text-sm">
            <img class="mb-4 w-64" src="@live/assets/images/logo-20-m.svg" />
            {{ $t('general.loading') }}
        </div>
        <template v-else>
            <div class="bg-black p-4 flex flex-col justify-between">
                <div class="flex flex-col">
                    <!-- <img class="mb-4" src="@live/assets/images/logo_ucraina_small_white.svg" /> -->
                    <img class="mb-4" src="@live/assets/images/logo-20-s-w.svg" />
                    <button class="hamburger hamburger--squeeze" :class="{'is-active': showLots}" type="button" @click="toggleLots">
                        <span class="hamburger-box">
                            <span class="hamburger-inner"></span>
                        </span>
                    </button>
                </div>
                <div class="flex flex-col divide-y divide-gray-500 p-0">
                    <div v-if="lot" class="text-center text-white text-xl font-bold py-1">
                        <template v-if="maxLot > 0">{{ maxLot }}</template>
                        <template v-else>{{ firstLot }}</template>
                    </div>
                    <div v-if="lots" class="text-center text-gray-500 text-sm font-bold py-1">{{ lastLot }}</div>
                </div>
                <div class="flex flex-col">
                    <div v-if="auction" class="text-center text-white text-sm font-bold">#{{ auction.no }}</div>
                    <div class="text-center text-gray-500 text-xs font-bold">{{ progress }}%</div>
                </div>
            </div>
            <div class="lots-list flex flex-col sm:flex-row container-fluid w-full h-full p-4 gap-4">
                <!-- Lista loturi -->
                <transition name="fade">
                    <lots v-if="showLots && lots && lots.length > 0"></lots>
                </transition>
                
                <!-- Imagine lot transmisie AV -->
                <transition name="fade">
                    <lot v-if="lot"></lot>
                    <div v-else class="flex-1 bg-white p-4 flex flex-col justify-center items-center">
                        {{ $t('general.loading') }}
                    </div>
                </transition>

                <!-- Lot curent, bid, desfasurare -->
                <transition name="fade">
                    <bid v-if="lot"></bid>
                    <div v-else class="lot-live-details no-lot flex-1 p-4 bg-white flex flex-col justify-center items-center">
                        {{ $t('general.loading') }}
                    </div>
                </transition>
            </div>
        </template>
        <AudioAnnouncementPrompt />
        <Welcome />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Vue from 'vue'
import Lots from './components/desktop/Lots'
import Lot from './components/desktop/Lot'
import Bid from './components/desktop/Bid'
import AudioAnnouncementPrompt from './components/global/AudioAnnouncementPrompt'
import { Constants } from './constants'
import Welcome from './components/modals/Welcome'

export default {
    name: 'Desktop',
    title () {
        return 'A10 Live'
    },
    components: {
        Lots, Lot, Bid, AudioAnnouncementPrompt, Welcome
    },
    data () {
        return {
            ...Constants,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'getLoading',
            user: 'getUser',
            auction: 'getAuction',
            lot: 'getLot',
            lots: 'getLots',
            bidders: 'getBidders',
            showLots: 'getShowLots',
            bids: 'getBids',
            winner: 'getWinner',
            recallTimer: 'getRecallTimer',
        }),
        firstLot() {
            return Math.min.apply(Math, this.lots.map(lot => lot.no))
        },
        lastLot () {
            return Math.max.apply(Math, this.lots.map(lot => lot.no))
        },
        maxLot () {
            return Math.max.apply(Math, this.lots.filter(lot => {return [this.LOT_AUCTION_STATUS_SOLD, this.LOT_AUCTION_STATUS_UNSOLD, this.LOT_AUCTION_STATUS_OPEN].includes(lot.s)}).map(lot => lot.no))
        },
        progress () {
            if(this.maxLot > 0) {
                return Math.ceil(this.maxLot / this.lastLot * 100)
            } else {
                return Math.ceil(this.firstLot / this.lastLot * 100)
            }
        },
        isRecallWindowActive() {
            return !!this.auction
                && [4, 5].includes(this.auction.md)
                && this.auction.s == this.AUCTION_LIVE_STATUS_ENDED
                && this.recallTimer > 0
        }
    },
    watch: {
        lot: {
            deep: true,
            handler() {
                document.title = `LOT ${this.lot.no}`
                if(this.lot.p > 0) {
                    document.title += ` €${this.lot.p}`
                }
                if(this.lot.k > 0) {
                    document.title += ` → €${this.lot.k}`
                }
            }
        },
        isRecallWindowActive(active) {
            if (active && ! this.showLots) {
                this.toggleLots()
            }
        }
    },
    methods: {
        toggleLots() {
            this.$store.dispatch('toggleLotsVisibility');
            if(! this.showLots) this.$store.commit('SET_SELECTED_LOT', null)
            if(! this.lot) return
            this.$nextTick(() => {
                let el = document.getElementById(`lot-id-${this.lot.id}`)
                if(el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
                }
            });
        }
    },
    mounted () {
        if (this.isRecallWindowActive && ! this.showLots) {
            this.toggleLots()
        }

        this.$modal.show('welcome')
    }
}
</script>
